import React, { useEffect, useRef, useState } from "react";
import { FilterIcon, PreviewIcon } from "../../../assets/icons";
import { IQuestion } from "../../../model/interface/question";
import Pagination from "../../shared/common/pagination";
import SelectPageSize from "../../shared/common/pageSizeDropdown";
import Loader from "../../shared/loader/loader";
import PreviewModal from "../questions/previewModal";
import { toast } from "react-toastify";
import { IunAssociateQuestion } from "../../../model/interface/unAssosiateQuestion";
import { Link } from "react-router";
import constant from "../../../utils/constant";
import { getSubjectsWithMultipleStandardsAPI } from "../../../api/subject.service";
import { UnAssociateQuestions } from "../../../api/question.service";

const ClassifyCleanup: React.FC = () => {
  const defaultPageSize = 20;
  const paginationRef: any = useRef(undefined);
  const pageSizeRef: any = useRef(undefined);
  const [subjectIds, setSubjectIds] = useState<string>("");
  const [excludeVideoQuestions, setExcludeVideoQuestions] =
    useState<boolean>(false);
  const [totalRecords, setTotalRecords] = useState<number>(0);
  const [loading, setLoading] = useState<boolean>(false);
  const [questions, setQuestions] = useState<any>([]);
  const [selectedQuestions, setSelectedQuestions] = useState<
    IunAssociateQuestion[]
  >([]);
  const [open, setOpen] = useState<boolean>(false);
  const [previewId, setPreviewId] = useState<string>("");
  const [questionToPreview, setQuestionToPreview] = useState<
    IQuestion | undefined
  >();
  const [questionIdPreview, setQuestionIdPreview] = useState<number>();
  const [questionIndexPreview, setQuestionIndexPreview] = useState<number>();
  const [pageSize, setPageSize] = useState(defaultPageSize);
  const [pageNumber, setPageNumber] = useState(1);
  const [totalPages, setTotalPages] = useState<number>(0);

  const getQuestions = () => {
    if (subjectIds) {
      setLoading(true);

      const response = getSubjectsWithMultipleStandardsAPI(
        subjectIds,
        excludeVideoQuestions,
        pageNumber,
        pageSize
      );
      response
        ?.then((d) => {
          setLoading(false);
          if (d.data.data.length > 0) {
            const data = d.data.data;

            setQuestions(data.map((d) => ({ ...d, isSelected: false })));
          }
          const pageCount = Math.ceil(d.data.totalRecords / pageSize);
          if (pageNumber > pageCount && pageNumber > 1) {
            setTotalPages(pageCount);
            setTotalRecords(d.data.totalRecords);
            setPageNumber(1);
          } else {
            setTotalPages(pageCount);
            setTotalRecords(d.data.totalRecords);
          }
        })
        .catch(() => {
          setLoading(false);
        });
    }
  };

  const standardsByQuestionId = () => {
    const result = questions.reduce((groups, question) => {
      if (
        groups.length == 0 ||
        groups[groups.length - 1].questionId != question.questionId
      )
        groups.push({ questionId: question.questionId, standards: [question] });
      else groups[groups.length - 1].standards.push(question);
      return groups;
    }, []);
    return result;
  };

  const handleSelectSingle = (
    isChecked: boolean,
    questionId: number,
    standardId: number
  ) => {
    const tempquestions = questions;
    const data = tempquestions.map((s) => {
      if (s.questionId === questionId && standardId === s.standardId) {
        s.isSelected = isChecked;
      }
      return s;
    });
    const speceficValues = (item) => ({
      questionId: `${item.questionId}`,
      standardId: item.standardId,
    });
    const selectedquestionids = data
      .filter((s) => s.isSelected)
      .map((s) => speceficValues(s));
    setSelectedQuestions(selectedquestionids);

    setQuestions(data);
  };
  useEffect(() => {
    getQuestions();
  }, [pageNumber, pageSize]);

  const openModal = (question) => {
    const questionId = question.questionId;
    if (!question?.englishQuestionReferenceId) {
      question.englishQuestionReferenceId = `${questionId}-en`;
      question.spanishQuestionReferenceId = `${questionId}-es`;
    }
    setOpen(true);
    setPreviewId(question?.englishQuestionReferenceId);
    setQuestionToPreview(question);
    setQuestionIdPreview(questionId);
  };
  const popUpClose = (value) => {
    setOpen(value);
    setPreviewId("");
    setQuestionIdPreview(undefined);
    setQuestionToPreview(undefined);
  };

  const getQuestionStandardsToDelete = () => {
    const standardsGrouped = selectedQuestions.reduce(
      (groups, question) => ({
        ...groups,
        [question.questionId]: [
          ...(groups[question.questionId] || []),
          question.standardId,
        ],
      }),
      {}
    );
    return Object.keys(standardsGrouped).map((questionId) => ({
      questionId: parseInt(questionId),
      standardIds: standardsGrouped[questionId],
    }));
  };

  const bulkDeleteQuestionStandardAssociation = async () => {
    setLoading(true);
    const data = getQuestionStandardsToDelete();
    await UnAssociateQuestions(data).finally(() => setLoading(false));
    getQuestions();
    setLoading(false);
    toast.success("Question(s) are unlinked successfully");
  };

  return (
    <div>
      {loading && <Loader />}
      <PreviewModal
        modal={openModal}
        show={open}
        changeValue={popUpClose}
        itemRef={previewId}
        questionIdPreview={questionIdPreview}
        questionIndexPreview={questionIndexPreview}
        setQuestionIndexPreview={setQuestionIndexPreview}
        questions={[]}
        setQuestionIdPreview={setQuestionIdPreview}
        setPreviewId={setPreviewId}
        questionToPreview={questionToPreview}
        setQuestionToPreview={setQuestionToPreview}
      ></PreviewModal>
      <div className="flex-1 overflow-auto">
        <div className=" h-auto min-h-half w-full rounded-bl-3xl bg-site-teal px-8  py-8 pt-0 pb-14 mt-7 ">
          <div className="relative  py-1">
            <div className="overlay-image-main pointer-events-none fixed left-0 top-0 w-screen h-screen z-20"></div>
            <div className="flex items-center justify-between">
              <h3 className="text-lg font-light text-gray-900">
                Classify Cleanup
              </h3>
            </div>

            <div className="pt-6 border-b pb-6">
              <div className="grid grid-cols-12 gap-6">
                <div className="col-span-6">
                  <label className="text-sm text-gray-700">
                    Subject Ids{" "}
                    <span className="font-light italic pl-10">
                      Note: Separate multiple Ids with a comma
                    </span>
                  </label>
                  <textarea
                    id="subjectIds"
                    name="subjectIds"
                    autoComplete="off"
                    rows={3}
                    className="block mt-1 w-full border border-gray-300 rounded-md shadow-sm py-2 px-3 focus:outline-none focus:ring-primary-color focus:border-primary-color dark:focus:border-gray-500 dark:focus:ring-gray-500 dark:bg-custom-black dark:text-white sm:text-sm"
                    value={subjectIds || ""}
                    onChange={(e: React.FormEvent<HTMLTextAreaElement>) =>
                      setSubjectIds(e.currentTarget.value)
                    }
                  />
                </div>
              </div>
              <div className="pt-6 border-b pb-6">
                <input
                  id="excludeVideoQuestions"
                  name="excludeVideoQuestions"
                  type="checkbox"
                  checked={excludeVideoQuestions}
                  onChange={(e) =>
                    setExcludeVideoQuestions(e.currentTarget.checked)
                  }
                  className=" focus:ring-primary-color h-4 w-4 text-primary-color border-gray-300 rounded"
                />
                <label className="ml-2 text-sm text-gray-700">
                  Exclude Video Questions
                </label>
              </div>
              <div className="mt-4">
                <button
                  type="submit"
                  className="inline-flex items-center text-sm text-white dark:text-white gap-2 bg-primary-color hover:bg-secondary-color py-1.5 px-4 rounded-lg"
                  onClick={getQuestions}
                >
                  <FilterIcon className="w-3 h-3"></FilterIcon>
                  <span>Filter</span>
                </button>
              </div>
            </div>

            <div id="dataContainer" className="mt-4">
              <div className="flex flex-col mt-1">
                <div className="-my-2 relative  sm:-mx-6 lg:-mx-8">
                  <div className="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
                    <div className="shadow border-b border-gray-200 sm:rounded-lg">
                      <table className="min-w-full divide-y divide-gray-200">
                        <thead className="bg-primary-color">
                          <tr>
                            <th
                              scope="col"
                              className="px-5 py-2 font-light whitespace-nowrap text-sm text-center text-white dark:text-white tracking-wider rounded-tl-lg"
                            >
                              <span className="flex">Preview</span>
                            </th>

                            <th
                              scope="col"
                              className="px-3 py-2 font-light whitespace-nowrap text-sm text-center text-white dark:text-white tracking-wider"
                            >
                              <span className="flex">Question Id</span>
                            </th>

                            <th
                              scope="col"
                              className="px-3 py-2 font-light whitespace-nowrap text-sm text-center text-white dark:text-white tracking-wider"
                            >
                              <span className="flex">Subject Name</span>
                            </th>
                            <th
                              scope="col"
                              className="px-3 py-2 font-light whitespace-nowrap text-sm text-center text-white dark:text-white tracking-wider"
                            >
                              <span className="flex">Domain Name</span>
                            </th>

                            <th
                              scope="col"
                              className="px-3 py-2 font-light whitespace-nowrap text-sm text-center text-white dark:text-white tracking-wider"
                            >
                              <span className="flex">Standard Id</span>
                            </th>

                            <th
                              scope="col"
                              className="px-3 py-2 font-light whitespace-nowrap text-sm text-center text-white dark:text-white tracking-wider"
                            >
                              <span className="flex">Standard Name</span>
                            </th>
                            <th
                              scope="col"
                              className="px-3 py-2 font-light whitespace-nowrap text-sm text-center text-white dark:text-white tracking-wider"
                            >
                              <span className="flex">Code</span>
                            </th>
                            <th
                              scope="col"
                              className="px-3 py-2 font-light whitespace-nowrap text-sm text-center text-white dark:text-white tracking-wider"
                            >
                              <span className="flex">Description</span>
                            </th>
                            <th
                              scope="col"
                              className="px-3 py-2 font-light whitespace-nowrap text-sm text-center text-white dark:text-white tracking-wider rounded-tr-lg"
                            >
                              <span className="flex">Select</span>
                            </th>
                          </tr>
                        </thead>

                        <tbody>
                          {standardsByQuestionId().map(
                            (question, questionIndex) =>
                              question.standards.map(
                                (standard, standardIndex) => (
                                  <tr
                                    key={`${questionIndex}-${standardIndex}`}
                                    className={`align-middle border-b ${
                                      questionIndex % 2 === 0
                                        ? "bg-white"
                                        : "bg-gray-100"
                                    }`}
                                  >
                                    {standardIndex === 0 && (
                                      <td
                                        rowSpan={question.standards.length}
                                        className="px-3 py-2 border-r text-sm text-center font-normal text-gray-500"
                                      >
                                        <a
                                          onClick={() => openModal(question)}
                                          className="text-gray-900 flex justify-center align-middle"
                                        >
                                          <PreviewIcon className="mr-3 h-5 w-5 text-xs font-light cursor-pointer text-gray-400 hover:text-secondary-color transaction ease-in-out duration-300" />
                                        </a>
                                      </td>
                                    )}
                                    {standardIndex === 0 && (
                                      <td
                                        className={`px-3 py-2 border-r ${
                                          questionIndex % 2 === 0
                                            ? "bg-white"
                                            : "bg-gray-100"
                                        }`}
                                        rowSpan={question.standards.length}
                                      >
                                        <div className="flex justify-center align-middle">
                                          <Link
                                            className="cursor-pointer font-medium text-indigo-600 hover:text-indigo-500 hover:underline"
                                            to={constant.MANAGEQUESTION.replace(
                                              ":id",
                                              question.questionId!.toString()
                                            )}
                                          >
                                            {question.questionId}
                                          </Link>
                                        </div>
                                      </td>
                                    )}
                                    <td className="px-3 py-2 capitalize text-sm font-normal text-gray-500">
                                      {standard.subjectName}
                                    </td>
                                    <td className="px-3 py-2 capitalize text-sm font-normal text-gray-500">
                                      {standard.domainName}
                                    </td>
                                    <td className="px-3 py-2 whitespace-nowrap text-sm font-normal text-gray-500">
                                      <Link
                                        className="cursor-pointer font-medium text-indigo-600 hover:text-indigo-500 hover:underline"
                                        to={constant.EDITSTANDARD.replace(
                                          ":id",
                                          standard.standardId!.toString()
                                        )}
                                      >
                                        {standard.standardId}
                                      </Link>
                                    </td>
                                    <td className="px-3 py-2 text-sm text-left font-normal text-gray-500">
                                      {standard.standardName}
                                      {" ["}
                                      {standard.totalQuestions}
                                      {"]"}
                                    </td>
                                    <td className="px-3 py-2 whitespace-nowrap text-sm font-normal text-gray-500">
                                      {standard.code}
                                    </td>
                                    <td className="px-3 py-3 flex justify-start items-center text-sm text-left font-normal text-gray-700">
                                      {standard.description}
                                    </td>
                                    <td className="px-3 py-2 whitespace-nowrap text-sm text-center font-normal text-gray-500">
                                      <input
                                        type="checkbox"
                                        className="h-4 w-4 cursor-pointer text-primary-violet border-gray-300 focus:ring-primary-violet"
                                        checked={standard.isSelected}
                                        onChange={(e) => {
                                          handleSelectSingle(
                                            e.target.checked,
                                            question.questionId,
                                            standard.standardId
                                          );
                                        }}
                                      />{" "}
                                    </td>
                                  </tr>
                                )
                              )
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
                <div className="flex justify-end pt-4">
                  <button
                    type="submit"
                    className={`mt-4 inline-flex items-center text-sm text-white dark:text-white gap-2 bg-primary-color hover:bg-secondary-color py-1.5 px-4 rounded-lg  ${
                      questions.length === 0 ? "hidden" : ""
                    }`}
                    onClick={bulkDeleteQuestionStandardAssociation}
                  >
                    <FilterIcon className="w-3 h-3"></FilterIcon>
                    <span>UnAssociate</span>
                  </button>
                </div>
                <div
                  className={`flex justify-between items-center ${
                    questions.length === 0 ? "hidden" : ""
                  }`}
                >
                  <Pagination
                    pages={totalPages}
                    setPageNumber={setPageNumber}
                    ref={paginationRef}
                  />
                  <span>
                    <span className="text-sm pr-4 ml-auto text-left-700">
                      Showing {1 + (pageNumber - 1) * pageSize} to{" "}
                      {totalRecords < pageSize
                        ? totalRecords
                        : pageSize * pageNumber}{" "}
                      of {totalRecords} results
                    </span>
                    <SelectPageSize
                      setPageSize={setPageSize}
                      type={"second"}
                      defaultPage={defaultPageSize}
                      ref={pageSizeRef}
                    />
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ClassifyCleanup;
